import { colors, fonts } from 'components/styles/variables';
import React, { useState, ReactElement } from 'react';
import Modal from 'react-modal';
import chevron from 'public/static/images/srp/Chevron.svg';

interface ModalDropdownContainerProps {
  children: ReactElement;
  placeHolderTitle: string;
  handleClick?: () => void;
  disabled?: boolean;
  styles?: ReactModal.Styles;
}

export default function ModalDropdownContainer({
  children,
  placeHolderTitle,
  handleClick,
  disabled,
  styles,
}: ModalDropdownContainerProps): JSX.Element {
  const [title, setTitle] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const modalStyles: ReactModal.Styles = {
    content: {
      display: 'flex',
      alignSelf: 'center',
      justifySelf: 'center',
      overflowY: 'hidden',
      padding: 0,
      inset: 'auto',
      placeSelf: 'center',
      ...styles?.content,
    },
    overlay: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1200,
      overflow: 'hidden',
      backgroundColor: 'rgba(0,0,0,0.4)',
      inset: '0',
      placeContent: 'center',
      placeItems: 'center',
      ...styles?.overlay,
    },
  };

  return (
    <>
      <button
        className={`dropdown ${disabled && 'dropdown-disabled'} modal-dropdown`}
        onClick={(): void => {
          if (!disabled) {
            setIsModalOpen(true);
            handleClick?.();
          }
        }}
      >
        <div className="dropdown-title">{title || placeHolderTitle}</div>
        <div className="chevron" />
      </button>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={(): void => setIsModalOpen(false)}
        shouldCloseOnOverlayClick={true}
        style={modalStyles}
        shouldCloseOnEsc
      >
        <>
          {React.cloneElement(children, {
            onListItemClick: (value: string) => setTitle(value),
            setIsModalOpen,
          })}
        </>
      </Modal>
      <style jsx>{`
        .dropdown {
          min-width: 248px;
          align-items: center;
          padding-left: 16px;
          display: flex;
          flex-direction: row;
          gap: 8px;
          background-color: ${colors.WHITE};
          height: 44px;
          border-radius: 4px;
          margin: 0 16px 16px 16px;
          border: 1px solid ${colors.G2};
          cursor: pointer;
          font-family: ${fonts.default};
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
        }

        .dropdown-disabled {
          color: colors.G3;
        }

        .dropdown-title {
          width: 100%;
          height: 44px;
          padding: 12px 0;
          line-height: 22px;
          whitespace: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .chevron {
          display: flex;
          background-image: url(${chevron});
          width: 14px;
          height: 9px;
          background-size: contain;
          background-repeat: no-repeat;
          padding-right: 24px;
        }

        .modal-dropdown {
          cursor: pointer;
          outline: inherit;
          text-align: inherit;
        }

        .dialog {
          max-height: 465px;
          min-width: 298px;
          overflow-y: hidden;
        }
      `}</style>
    </>
  );
}
